import styled from 'styled-components';

const TextStepContainer = styled.div`
  align-items: flex-end;
  display: flex;
  justify-content: ${props => (props.user ? 'flex-end' : 'flex-start')};
  margin-bottom: ${props => (props.user ? '0' : '8px')};
  min-width: 0;
  text-align: ${props => (props.user ? 'left' : 'inherit')};
  width: 100%;
`;

export default TextStepContainer;
